import { roofInitialGrid, roofLayoutSource } from "./roofInitialGrid";
import { layoutDesignChanged } from "./physicalLayoutDesign";

// A staging position for the editor, never a surveyed roof or a saved layout.
// Existing coordinates always win. Use a common, deterministic spacing so
// switching the edited surface cannot move the other groups in the scene.
export function roofWorkspaceFrames(planes) {
  const span = Math.max(12, ...planes.map((p) => {
    const roof = p.spacing?.site_geometry?.roof;
    return Math.max(Number(roof?.widthM) || 0, Number(roof?.depthM) || 0,
      Math.sqrt(Math.max(0, p.totalModules || 0)) * 3) + 4;
  }));
  const occupied = planes.map((p) => p.spacing?.site_geometry?.frame).filter(Boolean);
  const start = occupied.length ? Math.max(...occupied.map((f) => Number(f.eastM) || 0)) + span : 0;
  let unsaved = 0;
  return Object.fromEntries(planes.map((p) => [p.id, p.spacing?.site_geometry?.frame || {
    eastM: start + unsaved++ * span, northM: 0, elevationM: 0,
  }]));
}

export function roofWorkspacePlane(plane, { installationType, moduleLength, moduleWidth, portrait, frame, draft }) {
  const saved = roofLayoutSource(plane.spacing, installationType);
  const spacing = draft?.spacing || roofInitialGrid(saved, {
    installationType, moduleLength, moduleWidth, portrait, tilt: plane.tilt,
  });
  const siteGeometry = { version: 2, roof: null, ...(spacing?.site_geometry || {}),
    obstacles: spacing?.site_geometry?.obstacles ?? [],
    frame: spacing?.site_geometry?.frame || frame };
  if (siteGeometry.roof && installationType === "roof_flush") {
    siteGeometry.roof = { ...siteGeometry.roof, pitchDeg: plane.tilt, azimuthDeg: plane.azimuth };
  } else if (siteGeometry.roof) {
    siteGeometry.roof = { ...siteGeometry.roof,
      pitchDeg: plane.roofPitch ?? siteGeometry.roof.pitchDeg,
      azimuthDeg: plane.roofAzimuth ?? siteGeometry.roof.azimuthDeg };
  }
  return { ...plane, spacing, siteGeometry, tables: [],
    clearance: spacing?.ground_clearance_m ?? plane.clearance,
    roofPitch: installationType === "roof_flush" ? plane.tilt : plane.roofPitch,
    roofAzimuth: installationType === "roof_flush" ? plane.azimuth : plane.roofAzimuth,
    onRoof: true,
    tiers: Number(spacing?.row_vertical_modules) || 1,
    // Drafts can be drawn, but must not silently enter a saved shading table.
    previewOnly: Boolean(draft?.dirty || !saved?.site_geometry?.frame ||
      layoutDesignChanged(spacing, plane.totalModules, plane.electricalDesignKey) ||
      (Number(plane.totalModules) > 0 && !saved?.module_mapping_valid)),
  };
}
